'use client';

import MenuLink from '../link/MenuLink';
import { Menu as MenuType } from './types';

import { useLiveDataContext } from 'app/provider/DataLiveProvider';

interface Props {
  menu: MenuType;
  styles?: string;
}

export const LiveMenu = ({ menu, styles }: Props) => {
  const { data } = useLiveDataContext();

  return (
    <div
      className={`dropdown dropdown-hover flex h-full items-center lg:rounded-r-md ${data?.hasLive ? 'bg-red-600' : 'bg-gray-400'}`}
    >
      <div
        className={`inline-flex h-full items-center justify-center gap-1.5 rounded-lg px-5 ${styles}`}
      >
        <span
          className={`h-[10px] w-[10px] rounded-full ${data?.hasLive ? 'bg-white' : 'bg-white opacity-40'}`}
        />
        <MenuLink
          {...menu}
          prefetch={false}
          type={'top'}
          hoverMainMenuEffect={false}
          hoverTopMenuEffect={false}
          styles="flex items-center text-white group-hover:text-white h-full text-sm font-bold"
        />
      </div>
    </div>
  );
};
